<template>
  <div>
    <div class="card page-card-margin">
      <div class="card-header">
        {{web_texts.sys_info}}
      </div>
      <div class="card-body">
        <form action="" method="post" class="form-horizontal">
          <div class="form-group">
            <div class="row">
              <div class="col-md-1"></div>

              <label class="col-md-2 col-form-label"><b>{{web_texts.name}}</b></label>
              <label class="col-md-2 col-form-label">{{system.name}}</label>

              <div class="col-md-2"></div>

              <label class="col-md-3 col-form-label"><b>{{web_texts.type_invoice}}</b></label>
              <label class="col-md-1 col-form-label">{{system.access_rate}}</label>
              <div class="col-md-1"></div>
            </div>
            <br>
            <div class="row">
              <div class="col-md-1"></div>
              <label class="col-md-1 col-form-label"><b>P1</b></label>
              <label class="col-md-2 col-form-label">{{system.p1_contracted}} kW</label>

              <div class="col-md-1"></div>
              <label class="col-md-1 col-form-label"><b>P2</b></label>
              <label class="col-md-2 col-form-label">{{system.p2_contracted}} kW</label>

              <div class="col-md-1"></div>
              <label class="col-md-1 col-form-label"><b>P3</b></label>
              <label class="col-md-2 col-form-label">{{system.p3_contracted}} kW</label>
            </div>
            <div class="row" v-if="system.p4_contracted!==null">
              <div class="col-md-1"></div>
              <label class="col-md-1 col-form-label"><b>P4</b></label>
              <label class="col-md-2 col-form-label">{{system.p4_contracted}} kW</label>

              <div class="col-md-1"></div>
              <label class="col-md-1 col-form-label"><b>P5</b></label>
              <label class="col-md-2 col-form-label">{{system.p5_contracted}} kW</label>

              <div class="col-md-1"></div>
              <label class="col-md-1 col-form-label"><b>P6</b></label>
              <label class="col-md-2 col-form-label">{{system.p6_contracted}} kW</label>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        {{web_texts.app_info}}
      </div>
      <div class="card-body">
        <form action="" method="post" class="form-horizontal">
          <div class="form-group row">
            <div class="col-md-1"></div>

            <label class="col-md-2 col-form-label"><b>{{web_texts.app_version}}</b></label>
            <label class="col-md-2 col-form-label">v3.8.1</label>

            <div class="col-md-2"></div>

            <label class="col-md-3 col-form-label"><b>{{web_texts.system_energetic_control}}</b></label>
            <label class="col-md-1 col-form-label">&copy; 2019</label>
            <div class="col-md-1"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/InfoApp';
  import trans_es from '../translates/es/InfoApp';
  import middleware from "../utilities/middlewares";

  export default {
    name: 'InfoApp',
    data() {
      return {
        web_texts: { "sys_info": "Informació Sistema", "name": "Nom", "type_invoice": "Tipus Factura", "app_info": "Informació Aplicació", "app_version": "Versió de l'Aplicació", "system_energetic_control": "Systema Control Energetic" },
        system: [],
      }
    },
    created() {
      window.localStorage.setItem('real_time_control', '["info_app","info_app"]');
      this.system = JSON.parse(window.localStorage.getItem('system'));
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
    },
    mounted() {

    },
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// InfoApp.vue?75a6661c